import React from "react";

const MissionSection = () => {
  return (
    <section className="w-full bg-secondary-background pt-[50px] sm:pt-[75px] lg:pt-[100px]">
      <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-2 sm:gap-3 lg:gap-[10px] justify-start items-center max-w-[1281px] m-auto">
          <h2
            className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] text-[#183076] font-extrabold leading-[36px] sm:leading-[48px] md:leading-[60px] lg:leading-3xl text-center text-primary-background"
            style={{ fontFamily: "Bricolage Grotesque" }}
          >
            Our Mission
          </h2>

          <p
            className="text-[18px] sm:text-[20px] lg:text-[24px] text-[#183076] font-normal leading-[20px] sm:leading-[26px] lg:leading-[40px] text-center text-primary-background max-w-[1281px]"
            style={{ fontFamily: "Bricolage Grotesque" }}
          >
            To accelerate medical discovery and improve patient outcomes by
            delivering high- quality biospecimens for research and trusted
            diagnostic services for communities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
